import PropTypes from 'prop-types'
import { Button, Modal, Image } from 'react-bootstrap';
import { useState } from 'react'

const PhotoDetail = ({ resort, photo }) => {
    /*const [show, setShow] = useState(false)

    const handleClose = () => {
        setShow(false)
    }
    const showModal = () => {
        setShow(true)
    }*/
    return (
        <div>
            <div className="sj-box sj-box-blue sj-round-half left-aligned mt-3">
                <h4>{photo.Caption}</h4>
            </div>
            <div className='sj-row-small-margin-padding center-aligned'>
                <Image src={`${window.$baseAppUrl}/photo-galleries/${photo.CreatedByUserName}/${photo.PhotoFileName}`} alt={`thumb-${photo.Id}`} fluid='true' />
            </div>
            <div className="row sj-row-small-margin-padding">
                <div className="col-lg-2">
                    <strong>Uploaded by:</strong>
                </div>
                <div className="col-lg-10">
                    {photo.CreatedByUserName}
                </div>
            </div>
            <div className="row sj-row-small-margin-padding">
                <div className="col-lg-2">
                    <strong>Uploaded on:</strong>
                </div>
                <div className="col-lg-10">
                    {photo.CreatedAtDayTh} {photo.CreatedAtMonthFull} {photo.CreatedAtYear}
                </div>
            </div>
            <hr className='mt-5' />
            {/*<Modal
                show={show}
                size="lg"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{photo.Caption}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='center-aligned'>
                        <img src={`${window.$baseAppUrl}/photo-galleries/${photo.CreatedByUserName}/${photo.PhotoFileName}`} alt={`full-${photo.Id}`} />
                    </div>
                    <div className="row sj-row-small-margin-padding">
                        <div className="col-lg-3">
                            <strong>Uploaded by:</strong>
                        </div>
                        <div className="col-lg-9">
                            {photo.CreatedByUserName}
                        </div>
                    </div>
                    <div className="row sj-row-small-margin-padding">
                        <div className="col-lg-3">
                            <strong>Uploaded on:</strong>
                        </div>
                        <div className="col-lg-9">
                            {photo.CreatedAtDayTh} {photo.CreatedAtMonthFull} {photo.CreatedAtYear}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
    </Modal>*/}
        </div>
    )
};

PhotoDetail.propTypes = {
    photo: PropTypes.object.isRequired
}

export default PhotoDetail;